import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckSquareFill, PiSquareFill } from 'react-icons/pi';
import { ARTIST_ROLE } from 'services/types';
import './RoleSelectCard.scss';

interface IRoleSelectCardProps {
  role: ARTIST_ROLE;
  isSelected?: boolean;
  onClick?: (role: ARTIST_ROLE) => void;
  disabled?: boolean;
}

const RoleSelectCard = ({ role, isSelected, onClick, disabled }: IRoleSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('role-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(role)}
    >
      <div className="role-select-card-header">
        <div className="role-select-card-header-name">
          {t(`artist-role.${ARTIST_ROLE[role]}.name`)}
        </div>
        <div className="role-select-card-header-description">
          {t(`artist-role.${ARTIST_ROLE[role]}.description`)}
        </div>
      </div>
      {isSelected ? <PiCheckSquareFill /> : <PiSquareFill />}
    </div>
  );
};

export default RoleSelectCard;
